// src/encounter/ambient/ambient-window-words.ts
//
// `ambientWindow`: the words of the Start listening card and of the ambient window, and the window's first place (catalog
// scrips-signal-ds feat/signal @62cb3650, components/AmbientMic and AmbientScribe). Kept out of the component files so they export
// components only (react-refresh).

export const AMBIENT_START_WORDS = {
  start: 'Start listening',
  sub: 'Scrips drafts the note as you talk',
  /** B1 (Andrew, 3 Nov): on the pre-visit the same card starts the encounter first, then listening. Said on the button. */
  startWithEncounter: 'Start encounter and listen',
  subWithEncounter: 'Starts the encounter first, then Scrips drafts the note as you talk',
  listening: 'Listening',
  starting: 'Starting…',
  stop: 'Stop',
  transcript: 'Open transcript',
} as const;

export const AMBIENT_WINDOW_WORDS = {
  title: 'Ambient session',
  compact: 'Compact view',
  expand: 'Expand',
  collapse: 'Collapse',
  close: 'Close',
  move: 'Move the window',
} as const;

export type AmbientWindowSize = 'expanded' | 'compact' | 'collapsed';

const SIZES: Record<AmbientWindowSize, { w: number; h: number }> = {
  expanded: { w: 960, h: 640 },
  compact: { w: 420, h: 520 },
  collapsed: { w: 560, h: 52 },
};

/** The catalog's first place: bottom-centre, 100 to the left (over the rail's side of the page), 32 above the bottom, 16 from any edge. */
export function ambientWindowStart(size: AmbientWindowSize, vw: number, vh: number): { x: number; y: number; w: number; h: number } {
  const w = Math.min(SIZES[size].w, vw - 32);
  const h = Math.min(SIZES[size].h, vh - 32);
  return { x: Math.max(16, (vw - w) / 2 - 100), y: Math.max(16, vh - h - 32), w, h };
}

/** Keeps the whole window on screen (#904 review): the same limit for a drag, the arrow keys, a size change and a resize. */
export function ambientWindowClamp(p: { x: number; y: number }, box: { w: number; h: number }, vw: number, vh: number): { x: number; y: number } {
  return { x: Math.min(Math.max(0, p.x), Math.max(0, vw - box.w)), y: Math.min(Math.max(0, p.y), Math.max(0, vh - box.h)) };
}
